import { gql } from "@apollo/client";

export const SEND_SINGLE_BREEZE_TRANSACTION = gql`
  mutation startBreezeTransaction($paymentdata: CustomerPayment!) {
    startBreezeTransaction(paymentdata: $paymentdata) {
      breezePageId
      breezeUrl
      breezeClient
      breezeError
      wcTransactionId
    }
  }
`;
export const FINALIZE_BREEZE_TRANSACTION = gql`
  mutation finalizeBreezeTransaction(
    $breezePageId: String!
    $transactionId: String!
    $paymentdata: CustomerPayment!
  ) {
    finalizeBreezeTransaction(
      breezePageId: $breezePageId
      transactionId: $transactionId
      paymentdata: $paymentdata
    ) {
      wcstatus
      wcError
      wcData
      paymentdata
    }
  }
`;
